<div *ngIf="column !== property || direction === ''" class="mt-sort-header-icon">
    <img appImageSelector alt="mt-image" imageType="icon" imageKey="sort-up" style="margin-top: 8px;">
    <img appImageSelector alt="mt-image" imageType="icon" imageKey="sort-down" style="margin-top: -14px;">
</div>
<div *ngIf="direction === 'asc' && column === property" class="mt-sort-header-icon mt-sort-up">
    <img appImageSelector alt="mt-image" imageType="icon" imageKey="sort-up">
</div>
<div *ngIf="direction === 'desc' && column === property" class="mt-sort-header-icon mt-sort-down">
    <img appImageSelector alt="mt-image" imageType="icon" imageKey="sort-down">
</div>

